// @ts-strict

import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ISingleCampaign, ICampaignConfigFieldData, SpecialCampaignData } from '@app/core/models/core-models';
import { ShareOpenModalStatusService } from '@services/share-open-modal-status/share-open-modal-status.service';
import { IPostbackEditModalConfigData, IPostbackTestModalConfigData } from '@app/core/types/postback-api-config/postback-api-config.service.types';
import { CreatedConfigurationResponse } from '@services/url-address-config/url-address-config.types';
import { IBannerData } from '@services/banners/banners.service.types';
@Component({
  selector: 'app-single-campaign-modal',
  templateUrl: './single-campaign-modal.component.html',
  styleUrls: ['./single-campaign-modal.component.scss']
})
export class SingleCampaignModalComponent implements OnInit {
  @Input() watchInactiveCountries = false;
  @Input() campaignData?: ISingleCampaign | SpecialCampaignData;
  @Input() modalDescriptionName?: string = '';
  @Input() modalTitle: string = '';
  @Input() modalType: string = '';
  @Input() configurationData?: ICampaignConfigFieldData[] | IPostbackEditModalConfigData;
  @Input() landingOptionsData?: { id: number; name: string }[];
  @Input() configURL: string = '';
  @Input() configID?: number;
  @Input() postbackTestData?: IPostbackTestModalConfigData;
  @Input() editedElementID?: number;
  @Input() couponModal: boolean = false;
  @Input() configurationType: string = '';
  @Input() bannerConfigOnly: boolean = false;
  @Input() selectedBannerData: IBannerData | undefined = undefined;
  // below input is used for configuration creation that is invoked from other modal, not from campaign configurations list
  @Input() shortVersionWithoutSecondStep: boolean = false;
  @Input() onCountryClick?: (isActive: boolean, countryId?: number) => void;
  @Output() emitAction: EventEmitter<{ action: string; data: CreatedConfigurationResponse | undefined }> = new EventEmitter();
  @ViewChild('modalContainer') elementRef?: ElementRef<HTMLDivElement>;

  public longInnerContainer = false;
  public currentCampaignName: string = '';
  public isTitleHidden = false;

  constructor(
    public activeModal: NgbActiveModal,
    private shareOpenModalStatus: ShareOpenModalStatusService
  ) {}

  ngOnInit(): void {
    if (this.modalType === 'countries' || this.modalType === 'categories') {
      this.longInnerContainer = true;
    }
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef?.nativeElement.contains(event.target as Document)) {
      this.shareOpenModalStatus.shareModalStatus(false);
    }
  }

  public handleCountry = (countryId: number, isActive: boolean) => {
    const updatedCountries = this.campaignData?.countries?.map(country => (country.id === countryId ? { ...country, active: isActive } : country));
    this.campaignData = { ...(this.campaignData || {}), countries: updatedCountries || [] };
  };

  public switchTitleVisibility(isBannerConfigVisible: boolean): void {
    this.isTitleHidden = isBannerConfigVisible;
  }

  public closeModal(): void {
    this.shareOpenModalStatus.shareModalStatus(false);
    this.activeModal.close();
  }

  public emitActionForward(event: { action: string; data: CreatedConfigurationResponse | undefined }): void {
    this.emitAction.emit({ action: event.action, data: event.data });
  }
}
